/* rf-cart.js — shared AJAX cart behavior (shopify-data owned).
   P2-6: quick-add migrated here from the per-section inline script in
   rf-home-product-picks (per the P2-4t DECISIONS intent). Delegated on
   .rf-pcard__qadd so every rf-product-card grid gets it for free.
   Cart drawer = UpCart (KEEP per CLAUDE.md §8) — window.upcartOpenCart()
   is the verified opener; theme events are the fallback. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rf-pcard__qadd');
    if (!btn || btn.disabled) return;
    var id = parseInt(btn.dataset.rfVariant, 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = 'ADDED';
      /* open the cart drawer — UpCart first (verified opener), then theme events */
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
      else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
    }).catch(function () {
      btn.textContent = label;
      btn.disabled = false;
      var card = btn.closest('.rf-pcard');
      var link = card && card.querySelector('.rf-pcard__title a');
      if (link) window.location.href = link.href;
    });
  });
})();
